import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import isWeek from 'dayjs/plugin/isoWeek';
import localize from 'dayjs/plugin/localizedFormat';

dayjs.extend(utc);
dayjs.extend(isWeek);
dayjs.extend(localize);

dayjs.locale('es');

type tDayJSParam = string | Date | number | null

export const dayJsInstanceUTC = (date?: tDayJSParam): dayjs.Dayjs => dayjs(date).utc();
export const dayJsInstance = (date?: tDayJSParam): dayjs.Dayjs => dayjs(date);

export default class DatesFormat {
  public formatDate (date: string | null | undefined): string {
    if (date) {
      return dayJsInstance(date).format('ll');
    }
    return 'No disponible';
  }

  public formatDateTime (date: string | null | undefined): string {
    if (date) {
      return dayJsInstance(date).format('lll');
    }
    return 'No disponible';
  }

  public formatYear (date: string | null | undefined): string {
    if (date) {
      return dayJsInstance(date).format('MM-DD-YYYY');
    }
    return 'No disponible';
  }
}
